"use client";

import { Card, CardHeader, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Banknote } from "lucide-react";

interface PaymentStats {
  count: number;
  totalAmount: number;
}

interface StatsProps {
  title: string;
  stats: {
    cash: PaymentStats;
    pdq: PaymentStats;
  };
}

export const TransactionStatsCard = ({ title, stats }: StatsProps) => {
  return (
    <Card className="w-full max-w-md rounded-2xl hover:shadow-md transition-shadow duration-300">
      <CardHeader className="flex-row items-center gap-4">
        <div
          className={`bg-gradient-to-r from-accent to-accent grid place-content-center rounded-md shadow-lg h-10 w-10`}
        >
          <Banknote className="text-xl text-secondary" />
        </div>
        <span className={`text-sm font-semibold text-secondary`}>{title}</span>
      </CardHeader>
      <CardContent className="flex flex-col gap-4">
        <div className="space-y-2">
          <h3 className="text-lg font-semibold text-secondary">
           KES {(stats.cash.totalAmount + stats.pdq.totalAmount).toLocaleString()}
          </h3>
          <p className="text-sm text-primary">
            {stats.cash.count + stats.pdq.count} transactions
          </p>
        </div>
         <Separator />
        {Object.entries(stats).map(([method, data],index) => (
          <div key={index}>
          <div className="flex gap-4">
            <div key={method} className="flex flex-col">
              <span className="text-sm capitalize text-secondary font-semibold mb-1">
                {method}
              </span>
              <span className="text-sm mb-1">
                KES {data.totalAmount.toLocaleString()}
              </span>
              <span className="text-sm">{data.count} transactions</span>
            </div>
          </div>
         { index=== 0 && <Separator />}
          </div>
        ))}
      </CardContent>
    </Card>
  );
};
